import { _ as _applyDecoratedDescriptor, a as _initializerDefineProperty } from '../_rollupPluginBabelHelpers-3b0ba74f.js';
import Helper from '@ember/component/helper';
import { formatDate } from 'beebee-base/lib/utility';
import { inject } from '@ember/service';

var _class, _descriptor;

/**
 * Helper per formattare date con supporto timezone
 * Uso: {{format-date date}}                          → DD/MM/YYYY con tz sessione
 *      {{format-date date 'DD MMM YYYY'}}             → formato Moment personalizzato
 *      {{format-date date 'optimize'}}                → formato relativo (oggi/ieri/…)
 *      {{format-date date 'DD MMM YYYY' time_zone=tz}} → tz come named arg per override
 */
let FormatDateHelper = (_class = class FormatDateHelper extends Helper {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "session", _descriptor, this);
  }
  compute([date, format], {
    time_zone
  } = {}) {
    if (!date) return null;

    // timezone dalla sessione; time_zone named arg per override eccezionale
    const tz = time_zone ?? this.session.me?.time_zone;
    return formatDate(date, tz, format);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "session", [inject], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);

export { FormatDateHelper as default };
//# sourceMappingURL=format-date.js.map
